module.exports = __webpack_public_path__ + "media/images/pages/ic-filter-even-selected-a1fd68d5324ddc8e2d9f87c24971bd23.png";